export const CREATE_PAY_REQUEST = "CREATE_PAY_REQUEST";
export const CREATE_PAY_REQUEST_SUCCESS = "CREATE_PAY_REQUEST_SUCCESS";
export const CREATE_PAY_REQUEST_FAIL = "CREATE_PAY_REQUEST_FAIL";
export const CREATE_PAY_RESET = "CREATE_PAY_RESET";
